/** Shield embed + API - hosted on extra-api (VPS), not Vercel. */
export const SHIELD_API_URL =
  process.env.EXTRA_API_URL || 'https://extra-api.silkerai.com';

export const SHIELD_EMBED_URL = `${SHIELD_API_URL}/shield/embed.js`;
